import {
  Box,
  Divider,
  FormControl,
  Radio,
  RadioGroup,
  Stack,
  Text,
} from '@chakra-ui/react';
import { WarningComponent } from '@texas/components/shared/WarningComponent';
import { TexasFormLabel } from '@texas/components/shared/form/TexasFormLabel';
import { createArticleStyles as styles } from '@texas/resources/theme/styles/entityWorkspace';
import { useTranslation } from 'react-i18next';
import {
  ArticleNumberInput,
  ArticleNumberPosition,
} from '../copy/ArticleNumberFields';
import { useCreateArticle } from './useCreateArticle';

export function CreateArticleNumbering() {
  const { t } = useTranslation();
  const createArticle = useCreateArticle();
  return (
    <Box sx={styles.stack}>
      <FormControl>
        <TexasFormLabel>{t('article.copy.createMode')}</TexasFormLabel>
        <RadioGroup
          value={createArticle.mode}
          onChange={(value) =>
            createArticle.setValue('mode', value as 'single' | 'range')
          }
        >
          <Stack direction="row" spacing={6}>
            <Radio value="single">{t('article.copy.single')}</Radio>
            <Radio value="range">{t('article.copy.range')}</Radio>
          </Stack>
        </RadioGroup>
      </FormControl>
      <Divider />
      {createArticle.mode === 'range' && (
        <Box sx={styles.fields} id={createArticle.fieldWarnings.range.targetId}>
          <ArticleNumberInput
            variant="texas"
            label={t('article.create.from')}
            value={createArticle.start}
            onChange={(value) => createArticle.setValue('start', value)}
          />
          <ArticleNumberInput
            variant="texas"
            label={t('article.create.to')}
            min={createArticle.start}
            value={createArticle.end}
            onChange={(value) => createArticle.setValue('end', value)}
          />
          <ArticleNumberInput
            variant="texas"
            label={t('article.create.padding')}
            max={100}
            value={createArticle.padding}
            onChange={(value) => createArticle.setValue('padding', value)}
          />
          <ArticleNumberPosition
            variant="texas"
            label={t('article.create.position')}
            value={createArticle.position}
            onChange={(value) => createArticle.setValue('position', value)}
          />
        </Box>
      )}
      {createArticle.fieldWarnings.range.warning && (
        <WarningComponent {...createArticle.fieldWarnings.range}>
          <Text>{createArticle.fieldWarnings.range.warning}</Text>
        </WarningComponent>
      )}
    </Box>
  );
}
